import { useEffect, useState } from 'react'

interface Props {
  seconds: number
  onExpired: () => void
}

export function CountdownTimer({ seconds, onExpired }: Props) {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    setRemaining(seconds)
    const id = setInterval(() => {
      setRemaining(r => {
        if (r <= 1) {
          clearInterval(id)
          onExpired()
          return 0
        }
        return r - 1
      })
    }, 1000)
    return () => clearInterval(id)
  }, [seconds, onExpired])

  const mm = String(Math.floor(remaining / 60)).padStart(2, '0')
  const ss = String(remaining % 60).padStart(2, '0')

  return (
    <span className={remaining < 60 ? 'text-red-500 font-medium' : 'text-brand-500'}>
      {mm}:{ss}
    </span>
  )
}
